// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18mVa","comment":"styles_comment__2VRWv"};